export default __webpack_public_path__ + "static/media/icon2.4a06104e.png";